import * as Sentry from "@sentry/vue"
import accountTracker from "@/services/accountTracker"
import ApiStatusError from "@/api/errors/ApiStatusError"

export const useFetchAccountTracker = () => {
  const authStore = useAuthStore()
  const websiteInfoStore = useWebsiteInfoStore()

  const fetchAccountTracker = async () => {
    try {
      const { handler } = accountTracker

      const res = await handler()

      return Promise.resolve(res)
    } catch (error) {
      // 失敗代表這次登入沒有 accountTracker 紀錄(網路／HTTP 錯誤、後端 3001／9999)，
      // 呼叫端只 console.error，在這裡統一上報以保留觀測
      Sentry.captureException(error, {
        tags: { source: "accountTracker", context: "fetchAccountTracker" }
      })
      // captureException 受 prod sampleRate 抽樣；Logs 不抽樣，每筆失敗都可依 userId 對照後端
      Sentry.logger.error("[accountTracker] fetchAccountTracker failed", {
        userId: authStore.userID,
        isApp: websiteInfoStore.state.isApp,
        userAgent: navigator.userAgent,
        status: error instanceof ApiStatusError ? (error.status ?? "") : "",
        errorMessage: error instanceof Error ? error.message : String(error)
      })
      return Promise.reject(error)
    }
  }

  return {
    fetchAccountTracker
  }
}

export default useFetchAccountTracker
